
import {useEffect, useState} from 'react';
import {gql, useMutation} from '@apollo/client';
import {getLocalId} from 'utils/localId';

const getVisitors = gql`
mutation ($cache: ID!, $unique: ID!) {
	reports {
		updates(cache: $cache) {
			visitors(unique: $unique)
		}
	}
}`;

interface Vars {
	cache: string
	unique: string
}

interface Result {
	reports: {
		updates?: {
			visitors: number
		}
	}
}

export const useVisitors = (cache: string) => {
	const [visitors, setVisitors] = useState<number>(0);
	const [read]= useMutation<Result, Vars>(getVisitors, {
		onCompleted: (data) => {
			const value = data.reports.updates?.visitors;
			if (value) {
				setVisitors(value);
			}
		},
	});

	useEffect(() => {
		if (cache) {
			read({variables: {
				cache,
				unique: getLocalId(),
			}});
		}
	}, [cache]);

	return {visitors};
};
